<template>
    <div class="mt-6">
        <h3 class="text-center mt-3">Vuoi ricevere una consulenza dai nostri nutrizionisti?</h3>
        <p class="text-center mt-3">Compila il form a questo <a href="/contatta-nutrizionista">link</a> per ricevere un piano dedicato alle tue esigenze</p>
    </div>
</template>

<script>
export default {
    name: "GravityForm",
    data() {
        return {
        }
    }
}
</script>